import { Box, Collapse } from '@mui/material';
import PostFeed from './PostFeed';
import { useCallback } from 'react';
import { FeedItemT } from 'types/shared/core/Feeds';
import { FeedsPropsT } from './Feeds';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { observer } from 'mobx-react-lite';

type FeedRowPropsT = Omit<
  FeedsPropsT,
  'listKey' | 'feeds' | 'onClick' | 'onEnd'
> & {
  feed: FeedItemT;
  onClickFeed: (f: FeedItemT) => void;
  // RTG will inject these:
  in?: boolean;
  onExited?: () => void;
};

// TransitionGroup이 onExited 콜백을 새로 만들어 전달하므로 FeedRow는 추가로 리렌더된다.
// 내부 PostFeed는 observer의 props 비교로 같은 내용의 불필요한 리렌더를 방어한다.
// 따라서 FeedRow의 리렌더 횟수가 그대로 PostFeed의 리렌더 횟수를 뜻하지는 않는다.
const FeedRow = observer(
  ({
    feed,
    perspective,
    canOpenPostViewer,
    onClickPostViewer,
    onClickFeed,
    onClickPostCornerAction,
    CustomActionsComponent,
    in: inProp,
    onExited,
  }: FeedRowPropsT) => {
    console.log('FeedRow rerendered');

    const handleClick = useCallback(
      () => onClickFeed(feed),
      [onClickFeed, feed],
    );
    const handlePostCornerAction = useCallback(
      () => onClickPostCornerAction?.(feed.content),
      [onClickPostCornerAction, feed.content],
    );

    return (
      <Collapse
        in={inProp}
        onExited={onExited}
        timeout={300}
        unmountOnExit
        appear={false}
        enter={false}
      >
        <Box mb={1}>
          <PostFeed
            perspective={perspective}
            isPostViewerClickable={canOpenPostViewer?.(feed.content) ?? false}
            onClickPostViewer={onClickPostViewer}
            postFeedItem={feed.content} // observer component consumes it
            onClick={handleClick}
            cornerActionIcon={
              onClickPostCornerAction ? MoreHorizIcon : undefined
            }
            onClickPostCornerAction={
              onClickPostCornerAction
                ? handlePostCornerAction
                : undefined
            }
            CustomActionsComponent={CustomActionsComponent}
          />
        </Box>
      </Collapse>
    );
  },
);

export default FeedRow;
